import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userGrowthSparkRequestsAdapter = createEntityAdapter({})

const initialState = userGrowthSparkRequestsAdapter.getInitialState()

export const userGrowthSparkRequestsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserGrowthSparkRequests: builder.query({
            query: () => ({
                url: '/userGrowthSparkRequests/getUserGrowthSparkRequests',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserGrowthSparkRequests = responseData.map(userGrowthSparkRequest => {
                    userGrowthSparkRequest.id = userGrowthSparkRequest._id
                    return userGrowthSparkRequest
                })
                return userGrowthSparkRequestsAdapter.setAll(initialState, loadedUserGrowthSparkRequests)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserGrowthSparkRequest', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserGrowthSparkRequest', id}))
                    ]
                } else {
                    return [ { type: 'UserGrowthSparkRequest', id: 'LIST'}]
                }
            },
        }),
        createNewUserGrowthSparkRequest: builder.mutation({
            query: initialUserGrowthSparkRequest => ({
                url: '/userGrowthSparkRequests/createNewUserGrowthSparkRequest',
                method: 'POST',
                body: {...initialUserGrowthSparkRequest,}
            }),
            invalidatesTags: [
                { type: 'UserGrowthSparkRequest', id: "LIST" }
            ] 
        }),
        updateUserGrowthSparkRequest: builder.mutation({
            query: initialUserGrowthSparkRequest => ({
                url: '/userGrowthSparkRequests/updateUserGrowthSparkRequest',
                method: 'PATCH',
                body: {...initialUserGrowthSparkRequest,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserGrowthSparkRequest', id: arg.id },
                { type: 'UserGrowthSparkRequest', id: 'LIST' }
            ],
        }),
        deleteUserGrowthSparkRequest: builder.mutation({
            query: ({id}) => ({
                url: '/userGrowthSparkRequests/deleteUserGrowthSparkRequest',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserGrowthSparkRequest', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserGrowthSparkRequestsQuery,
    useCreateNewUserGrowthSparkRequestMutation,
    useUpdateUserGrowthSparkRequestMutation,
    useDeleteUserGrowthSparkRequestMutation,
} = userGrowthSparkRequestsApiSlice

// returns the query result object
export const selectUserGrowthSparkRequestResult = userGrowthSparkRequestsApiSlice.endpoints.getUserGrowthSparkRequests.select()

// create memoized selector
const selectUserGrowthSparkRequestsData = createSelector(
    selectUserGrowthSparkRequestResult,
    userGrowthSparkRequestResult => userGrowthSparkRequestResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserGrowthSparkRequests,
    selectById: selectUserGrowthSparkRequestById,
    selectIds: selectUserGrowthSparkRequestIds,
} = userGrowthSparkRequestsAdapter.getSelectors(state => selectUserGrowthSparkRequestsData(state) ?? initialState)